require('./formValidation');

/**
 *
 * @param {HTMLElement} field
 * @param {String} currentClass
 * @param {String} replacingClass
 */
function swapClasses(field, currentClass, replacingClass) {
	field.classList.remove(currentClass);
	field.classList.add(replacingClass);
}

/**
 *
 * @param {HTMLElement} field
 * @param {('error'|'normal')} state
 */
function setRadioTheme(field, state) {
	const parent = field.closest('div.radio-container');
	const theme = field.dataset.inputTheme;
	const textClasses = {
		text: { light: 'text-white', dark: 'text-black' },
		border: { light: 'border-white', dark: 'border-black' },
	};

	const mainLabel = parent.querySelector('p');
	const radioDisplays = parent.querySelectorAll('label > div');
	if (state === 'error') {
		swapClasses(mainLabel, textClasses.text[theme], 'text-rose');
		radioDisplays.forEach((display) => {
			swapClasses(display, textClasses.border[theme], 'border-error-red');
		});
	} else {
		swapClasses(mainLabel, 'text-rose', textClasses.text[theme]);
		radioDisplays.forEach((display) => {
			swapClasses(display, 'border-error-red', textClasses.border[theme]);
		});
	}
}

/**
 *
 * @param {HTMLInputElement} field
 * @param {String} message
 * @param {String} identifier
 * @returns {Boolean}
 */
function setRadioValidityMessage(field, message, identifier) {
	try {
		const parent = field.closest('div.radio-container');
		const prevMessage = parent.querySelector(`span.${identifier}`);
		const theme = field.dataset.inputTheme;

		if (prevMessage) return false;

		const errorElement = document.createElement('span');
		errorElement.innerText = message;
		errorElement.className = `block error-message ${identifier}`;

		if (theme === 'light') {
			errorElement.classList.add('text-rose');
		} else errorElement.classList.add('text-error-red');

		parent.insertAdjacentElement('beforeend', errorElement);
		return false;
	} catch (err) {
		console.log(err);
		return false;
	}
}

function setValidityMessage(field, message, identifier) {
	const parent = field.parentElement;
	const prevMessage = parent.querySelector(`span.${identifier}`);
	if (prevMessage) return false;
	if (field.type === 'radio') {
		return setRadioValidityMessage(field, message, identifier);
	}
	const elt = document.createElement('span');
	elt.innerText = message;
	elt.classList.add('block', 'ml-4', 'error-message', identifier);
	if (
		field.classList.contains('input-dark') ||
		field.classList.contains('file-input-filled-display-dark') ||
		field.classList.contains('select-input-display-dark') ||
		field.classList.contains('textarea-dark')
	) {
		elt.classList.add('text-error-red');
	} else if (
		field.classList.contains('input-light') ||
		field.classList.contains('file-input-filled-display-light') ||
		field.classList.contains('select-input-display-light') ||
		field.classList.contains('textarea-light')
	) {
		elt.classList.add('text-rose');
	}
	parent.insertAdjacentElement('beforeend', elt);
	return false;
}

function removeValidityMessage(field, identifier) {
	try {
		let parent = field.parentElement;
		if (field.type === 'radio') {
			parent = field.closest('div.radio-container');
		}
		const msg = parent.querySelector(identifier);
		if (msg) msg.remove();
	} catch (err) {
		console.log(err);
	}
}

//    1.a if the field is not valid
//        - border and text color of field and label are adjusted
//        - if field has invalid property the error message is set on the
//          parent element and color is adjusted based on theme
//    1.b if the field is valid
//        - border and text color of field and label are adjusted
//        - error messages are removed from parent element.
export function checkValidity(field) {
	try {
		const inputLabel = field.parentElement.querySelector(
			`label[for="${field.id}"]`,
		);
		const parent = field.parentElement;
		const isItemHidden =
			(field.classList.contains('hidden') || !!field.closest('.hidden')) &&
			!field.dataset.checkHidden;
		if (inputLabel && !isItemHidden) {
			// Method for custom field validation
			if (field.validateInput && typeof field.validateInput === 'function') {
				field.validateInput(field.value);
			}
			if (
				!field.validity.valid ||
				(field.hasOwnProperty('isValid') && !field.isValid)
			) {
				removeValidityMessage(field, 'span.error-message');
				if (
					field.classList.contains('input-dark') ||
					field.classList.contains('textarea-dark')
				) {
					inputLabel.classList.add('!text-error-red');
					field.classList.add('!border-error-red', '!text-error-red');
				} else if (
					field.classList.contains('input-light') ||
					field.classList.contains('textarea-light')
				) {
					inputLabel.classList.add('!text-rose');
					field.classList.add('!border-error-red', '!text-rose');
				}

				if (field.type === 'radio') setRadioTheme(field, 'error');

				if (field.validity.valueMissing) {
					return setValidityMessage(
						field,
						FIELD_REQUIRED_MESSAGE,
						'field-required-message',
					);
				} else {
					removeValidityMessage(field, 'span.field-required-message');
				}
				if (
					(field.validity.valueMissing || field.validity.typeMismatch) &&
					field.type === 'email'
				) {
					return setValidityMessage(
						field,
						EMAIL_REQUIRED_MESSAGE,
						'email-message',
					);
				} else {
					removeValidityMessage(field, 'span.email-message');
				}
				if (field.hasOwnProperty('isValid') && !field.isValid) {
					const errMessage =
						field.errMessage || 'Bitte geben Sie eine gültige Eingabe ein';
					return setValidityMessage(field, errMessage, 'error-message');
				}
			} else {
				const errMessages = parent.querySelectorAll('span.error-message');
				errMessages.forEach((el) => {
					el.remove();
				});
				if (field.type === 'radio') {
					const messages = field
						.closest('div.radio-container')
						.querySelectorAll('span.error-message');
					messages.forEach((message) => {
						message.remove();
					});
					setRadioTheme(field, 'normal');
				}
				if (
					field.classList.contains('input-dark') ||
					field.classList.contains('textarea-dark')
				) {
					field.classList.remove('!border-error-red', '!text-error-red');
					inputLabel.classList.remove('!text-error-red');
				} else if (
					field.classList.contains('input-light') ||
					field.classList.contains('textarea-light')
				) {
					field.classList.remove('!border-error-red', '!text-rose');
					inputLabel.classList.remove('!text-rose');
				}
				return true;
			}
		} else if (field.type === 'file' && field?.multiple === false) {
			if (
				!field.validity.valid ||
				(field.hasOwnProperty('isValid') && !field.isValid)
			) {
				setFileDisplayState({
					element: field,
					hasError: true,
					errorMessage: field.errMessage,
				});
				return false;
			} else {
				setFileDisplayState({ element: field, hasError: false });
				return true;
			}
		} else if (field.type === 'file' && field.multiple === true) {
			const filesLength = Array.from(field.files).length;
			if (filesLength === 0 && field.hasAttribute('required')) {
				field.parentNode
					.querySelector('.required-error-message')
					.classList.remove('hidden');
				return false;
			} else {
				field.parentNode
					.querySelector('.required-error-message')
					.classList.add('hidden');
			}
			return field.getAttribute('data-invalid') !== 'true';
		} else if (field.type === 'checkbox') {
			return true;
		}
	} catch (err) {
		console.log(err);
	}
}

export function checkSelectValidity(element) {
	const selectContainer = element.parentElement.querySelector(
		'[class*=select-input-display]',
	);
	if (!selectContainer) return;
	if (!element.validity.valid) {
		if (selectContainer.classList.contains('select-input-display-dark')) {
			selectContainer.classList.remove(
				'[&>.select-curr-selected]:text-black',
				'[&>.select-icons>svg]:fill-black',
				'[&>.select-label]:text-black',
				'border-black',
			);
			selectContainer.classList.add(
				'[&>.select-curr-selected]:text-error-red',
				'[&>.select-icons>svg]:fill-error-red',
				'[&>.select-label]:text-error-red',
				'border-error-red',
			);
		} else if (
			selectContainer.classList.contains('select-input-display-light')
		) {
			selectContainer.classList.remove(
				'[&>.select-curr-selected]:text-white',
				'[&>.select-icons>svg]:fill-white',
				'[&>.select-label]:text-white',
				'border-white',
			);
			selectContainer.classList.add(
				'[&>.select-curr-selected]:text-rose',
				'[&>.select-icons>svg]:fill-rose',
				'[&>.select-label]:text-rose',
				'border-error-red',
			);
		}
		return false;
	} else {
		if (selectContainer.classList.contains('select-input-display-dark')) {
			selectContainer.classList.add(
				'[&>.select-curr-selected]:text-black',
				'[&>.select-icons>svg]:fill-black',
				'[&>.select-label]:text-black',
				'border-black',
			);
			selectContainer.classList.remove(
				'[&>.select-curr-selected]:text-error-red',
				'[&>.select-icons>svg]:fill-error-red',
				'[&>.select-label]:text-error-red',
				'border-error-red',
			);
		} else if (
			selectContainer.classList.contains('select-input-display-light')
		) {
			selectContainer.classList.add(
				'[&>.select-curr-selected]:text-white',
				'[&>.select-icons>svg]:fill-white',
				'[&>.select-label]:text-white',
				'border-white',
			);
			selectContainer.classList.remove(
				'[&>.select-curr-selected]:text-rose',
				'[&>.select-icons>svg]:fill-rose',
				'[&>.select-label]:text-rose',
				'border-error-red',
			);
		}
		return true;
	}
}

export const inputFields = document.querySelectorAll('input,textarea');
inputFields.forEach((field) => {
	// get label for field
	const inputLabel = field.parentElement.querySelector(
		`label[for="${field.id}"]`,
	);

	// if there is input label change text color when field is disabled
	// and focus on field when lable is clicked (not working as it should)
	if (inputLabel) {
		if (field.disabled) inputLabel.classList.add('!text-gray-light');
		else inputLabel.classList.remove('!text-gray-light');
		inputLabel.addEventListener('click', function (_) {
			field.focus();
		});
	}
	////
	// When the input field is focused
	// - the label is selected and properly formatted to appear on the border
	field.addEventListener('focus', function (_) {
		const inputLabel = field.parentElement.querySelector(
			`label[for="${field.id}"]`,
		);
		// if (!field.valid) inputLabel.classList.add("text-error-red")
		if (inputLabel) {
			const activeBackground = inputLabel.getAttribute(
				'data-active-background',
			);
			inputLabel.getBoundingClientRect().height;

			if (CSS.supports('color', activeBackground))
				inputLabel.style.backgroundColor = activeBackground;
			else inputLabel.classList.add(activeBackground);
			inputLabel.classList.remove(
				'-translate-y-7',
				'text-[16px]',
				'leading-[22px]',
			);
			let htmlInputElement = inputLabel.parentElement.querySelector('input');
			if (htmlInputElement) {
				htmlInputElement.style.minHeight = '';
			}

			inputLabel.classList.add(
				'-translate-y-7',
				'text-[12px]',
				'leading-[16px]',
				'font-medium',
			);
		}
	});

	// When the focusout event is fired
	// 1. add border and text color for invalid state for
	//    each theme.
	// 2. check validity of the field
	// 3. move label to field if there is no value entered.
	field.addEventListener('focusout', function (_) {
		if (field.classList.contains('input-dark')) {
			field.classList.add('invalid:border-error-red', 'invalid:text-error-red');
		} else if (field.classList.contains('input-light')) {
			field.classList.add('invalid:border-error-red', 'invalid:text-rose');
		}
		checkValidity(field);
		if (!field.value) {
			const activeBackground = inputLabel.getAttribute(
				'data-active-background',
			);
			if (CSS.supports('color', activeBackground))
				inputLabel.style.backgroundColor = 'transparent';
			else inputLabel.classList.remove(activeBackground);
			inputLabel.classList.remove(
				'-translate-y-7',
				'text-[12px]',
				'leading-[16px]',
				'font-medium',
				'break-all',
			);
			// Waiting for height is adjusted before calculation
			setTimeout(() => {
				const labelHeight = inputLabel.getBoundingClientRect().height;
				inputLabel.parentElement.querySelector('input').style.minHeight = `${
					labelHeight * 2.15
				}px`;
			}, 175);
		}
	});

	/////
	// check validity of field When the input event is fired
	field.addEventListener('input', function (_) {
		checkValidity(field);
	});
});

// File input handling
// used for triggering native input element
export const fileInputContainers = document.querySelectorAll(
	'.file-input-container',
);
fileInputContainers.forEach((fileInput) => {
	fileInput.addEventListener('click', function (_) {
		const input = fileInput.parentElement.querySelector('input[type="file"]');
		input.click();
	});
});

const radioContainers = document.querySelectorAll([
	'[data-controller="radio"]',
]);
radioContainers.forEach((container) => {
	const nativeRadios = container.querySelectorAll('input');
	const radioItems = container.querySelectorAll('li');
	radioItems.forEach((item) => {
		const input = item.querySelector('input');
		const label = item.querySelector('label');

		label.setAttribute('aria-checked', input.checked ? 'true' : 'false');
		label.setAttribute('tabindex', '0');

		input.addEventListener('click', () => {
			toggleRadioChecked(nativeRadios, input);
		});

		label.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				toggleRadioChecked(nativeRadios, input);
			}
		});
	});
});

function toggleRadioChecked(nativeRadios, input) {
	nativeRadios.forEach((radio) => {
		const currentLabel = radio.closest('li').querySelector('label');
		const indicatorContainer = radio
			.closest('li')
			.querySelector('.input-radio-display');
		const selectedIndicator = indicatorContainer.querySelector('span');
		if (radio.id === input.id) {
			selectedIndicator.classList.remove('w-0');
			selectedIndicator.classList.add('w-2.5');
			radio.checked = true;
			currentLabel.setAttribute('aria-checked', 'true');
			document.dispatchEvent(
				new CustomEvent('radioValueChanged', {
					bubbles: true,
					detail: {
						name: radio.name,
						checkedValue: radio.value,
					},
				}),
			);
		} else {
			selectedIndicator.classList.remove('w-2.5');
			selectedIndicator.classList.add('w-0');
			radio.checked = false;
			currentLabel.setAttribute('aria-checked', 'false');
		}
	});
}

function bytesToKB(bytes) {
	return (bytes / 1024).toFixed(2);
}

function bytesToMB(bytes) {
	return (bytes / (1024 * 1024)).toFixed(2);
}

// toggles to decide whether to show if file is selected or not.
// if file is selected:
// 	- hides the empty display container and displays the filled container.
// else
//	- hides the filled display container and displays the empty container.
async function toggleFileSelected(fileInputEl, useJsFileInput) {
	const sizeDisplay = fileInputEl.parentElement.querySelector(
		'.file-input-size-display',
	);
	const emptyDisplayContainer = fileInputEl.parentElement.querySelector(
		'.file-input-empty-display-dark , .file-input-empty-display-light',
	);
	const filledDisplayContainer = fileInputEl.parentElement.querySelector(
		'.file-input-filled-display-dark , .file-input-filled-display-light',
	);

	const jsFileInput = fileInputEl.parentElement.querySelector(
		'[data-js-file-setter]',
	);
	if (fileInputEl.files.length > 0) {
		const currFile = fileInputEl.files[0];
		jsFileInput.href = URL.createObjectURL(currFile);
		jsFileInput.setAttribute('data-file-size', currFile.size);
		jsFileInput.setAttribute('data-file-type', currFile.type);
		jsFileInput.setAttribute('data-file-name', currFile.name);
		// localStorage.setItem(currFile.name, await read(currFile))
	} else if (fileInputEl.files.length !== 0 && useJsFileInput) {
		// localStorage.removeItem(currFile.name)
		jsFileInput.href = '';
		jsFileInput.setAttribute('data-file-size', '');
		jsFileInput.setAttribute('data-file-type', '');
		jsFileInput.setAttribute('data-file-name', '');
	}
	if (
		fileInputEl.files.length > 0 ||
		(jsFileInput.href !== window.location.href && useJsFileInput)
	) {
		const fileSize =
			fileInputEl.files[0]?.size || parseInt(jsFileInput.dataset.fileSize);
		sizeDisplay.innerText =
			bytesToKB(fileSize) > 1000
				? `${bytesToMB(fileSize)}MB`
				: `${bytesToKB(fileSize)}KB`;
		emptyDisplayContainer.classList.add('hidden', 'opacity-0');
		emptyDisplayContainer.classList.remove('opacity-1');

		filledDisplayContainer.classList.remove('hidden', 'opacity-0');
		filledDisplayContainer.classList.add('opacity-1');
	} else {
		emptyDisplayContainer.classList.remove('hidden', 'opacity-0');
		emptyDisplayContainer.classList.add('opacity-1');

		filledDisplayContainer.classList.add('hidden', 'opacity-0');
		filledDisplayContainer.classList.remove('opacity-1');
	}
}

// validates whether file input does not fulfil maximum size requirement.
// if size requirements are not met:
// 	- error is displayed for the field.
// else:
//  - error is removed if it was previously displayed
export function fileMaxSizeValidator(element) {
	const maxSize = element.getAttribute('data-max-size');
	const maxSizeDisplay =
		bytesToKB(maxSize) > 1000
			? `${bytesToMB(maxSize)}MB`
			: `${bytesToKB(maxSize)}KB`;

	const elFileSize = element.files[0]?.size;
	const jsInput = element.parentElement.querySelector('[data-js-file-setter]');
	const jsFileSize = jsInput.dataset.fileSize;
	const fileSize = elFileSize ? elFileSize : jsFileSize;

	if (!maxSize || !fileSize) return true;

	element.isValid = fileSize <= +maxSize;
	element.errMessage = `${FILE_TOO_LARGE_MESSAGE} ${maxSizeDisplay}`;
	return checkValidity(element);
}

function setFileDisplayState({
	element,
	hasError = false,
	errorMessage = `${FILE_TOO_LARGE_MESSAGE}`,
}) {
	const filledDisplayContainer = element.parentElement.querySelector(
		'.file-input-filled-display-dark , .file-input-filled-display-light',
	);
	const filledDisplayFileSize = filledDisplayContainer.querySelector(
		'.file-input-size-display',
	);
	const filledDisplayFileType = filledDisplayContainer.querySelector(
		'.file-input-type-display',
	);
	const removeFileInputIcon = filledDisplayContainer.querySelector(
		'.remove-file-input-icon, .remove-file-input-svg',
	);
	const fileTypeIcon = filledDisplayContainer.querySelector('.file-type-icon');

	if (hasError) {
		filledDisplayFileSize.classList.remove('text-gray-medium');
		filledDisplayFileSize.classList.add('text-error-red');
		filledDisplayFileType.classList.add('text-error-red');
		removeFileInputIcon.classList.add('fill-error-red', 'hover:fill-red-500');
		removeFileInputIcon.classList.remove('hover:fill-gray-medium');
		fileTypeIcon.classList.add('fill-error-red', 'hover:fill-red-500');
		fileTypeIcon.classList.remove('hover:fill-gray-medium');
		if (
			filledDisplayContainer.classList.contains(
				'file-input-filled-display-dark',
			)
		) {
			filledDisplayContainer.classList.remove(
				'[&>svg]:fill-black',
				'[&>div>p]:text-black',
			);
		} else {
			filledDisplayContainer.classList.remove(
				'[&>svg]:fill-white',
				'[&>div>p]:text-white',
			);
		}
		filledDisplayContainer.classList.add(
			'[&>svg]:fill-error-red',
			'[&>div>p]:text-error-red',
			'border-error-red',
			'bg-rose',
		);
		return setValidityMessage(
			filledDisplayContainer,
			errorMessage,
			'max-file-size-error',
		);
	} else {
		filledDisplayFileSize.classList.add('text-gray-medium');
		filledDisplayFileSize.classList.remove('text-error-red');
		filledDisplayFileType.classList.remove('text-error-red');
		removeFileInputIcon.classList.remove(
			'fill-error-red',
			'hover:fill-red-500',
		);
		removeFileInputIcon.classList.add('hover:fill-gray-medium');
		fileTypeIcon.classList.remove('fill-error-red', 'hover:fill-red-500');
		fileTypeIcon.classList.add('hover:fill-gray-medium');
		// filledDisplayContainer.classList.add('bg-[#F1F1ECCC]')
		filledDisplayContainer.classList.remove(
			'[&>svg]:fill-error-red',
			'[&>div>p]:text-error-red',
			'border-error-red',
			'bg-rose',
		);
		if (
			filledDisplayContainer.classList.contains(
				'file-input-filled-display-dark',
			)
		) {
			filledDisplayContainer.classList.add(
				'[&>svg]:fill-black',
				'[&>div>p]:text-black',
			);
		} else {
			filledDisplayContainer.classList.add(
				'[&>svg]:fill-white',
				'[&>div>p]:text-white',
			);
		}
		return removeValidityMessage(
			filledDisplayContainer,
			'.max-file-size-error',
		);
	}
}

// checks if file is selected and max size criteria is met upon
// input
export const fileInputs = document.querySelectorAll('.input-file');
fileInputs.forEach((el) => {
	el.addEventListener('input', function (ev) {
		toggleFileSelected(el, !!ev.detail);
		fileMaxSizeValidator(el);
	});
});

// uses the close Icon on the file type to
export const removeItemIcons = document.querySelectorAll(
	'.remove-file-input-icon',
);
removeItemIcons.forEach((icon) => {
	const input =
		icon.parentElement.parentElement.querySelector('input[type="file"]');

	icon.addEventListener('click', function (ev) {
		ev.preventDefault();
		ev.stopPropagation();
		input.value = null;
		const jsInput = input.parentElement.querySelector('[data-js-file-setter]');
		jsInput.href = '';
		jsInput.setAttribute('data-file-name', '');
		jsInput.setAttribute('data-file-size', '');
		jsInput.setAttribute('data-file-type', '');
		toggleFileSelected(input);
		input.isValid = true;
		setFileDisplayState({
			element: input,
			hasError: false,
		});
	});
});

// select field

export function toggleOptions(options) {
	const selectUpIcon = options.parentElement.querySelector('.select-icon-up');
	const selectDownIcon =
		options.parentElement.querySelector('.select-icon-down');
	const allOptions = document.querySelectorAll('.select-input-options');
	allOptions.forEach((currOption) => {
		if (currOption.id !== options.id) {
			if (!currOption.classList.contains('hidden')) {
				currOption.classList.add('hidden');
				currOption.classList.remove('flex');
			}
		}
	});
	if (options.classList.contains('hidden')) {
		options.classList.remove('hidden');
		options.classList.add('flex');
		selectUpIcon.classList.remove('hidden');
		selectDownIcon.classList.add('hidden');
	} else {
		options.classList.remove('flex');
		options.classList.add('hidden');
		selectUpIcon.classList.add('hidden');
		selectDownIcon.classList.remove('hidden');
	}
}

const selectInputDisplays = document.querySelectorAll(
	'[class*=select-input-display]',
);
const selectInputOptions = document.querySelectorAll('.select-input-options');

const nativeSelects = document.querySelectorAll('.select-input');

nativeSelects.forEach((nativeSelect) => {
	if (nativeSelect.disabled) {
		const display = nativeSelect.parentElement.querySelector(
			'[class*=select-input-display]',
		);

		display.classList.add(
			'border-gray-light',
			'[&>.select-curr-selected]:text-gray-light',
			'[&>.select-icons>svg]:fill-gray-light',
			'[&>.select-label]:text-gray-light',
		);
	}
});

selectInputDisplays.forEach((selectInput) => {
	const nativeSelect = selectInput.parentElement.querySelector('.select-input');
	const optionsList = selectInput.parentElement.querySelector(
		'.select-input-options',
	);

	const options = Array.from(optionsList.querySelectorAll('li'));
	let currentFocusIndex = -1;

	const openDropdown = () => {
		const hasMultipleOptions = () =>
			Array.from(nativeSelect.options).length > 1;
		if (hasMultipleOptions()) {
			optionsList.classList.remove('hidden');
			optionsList.classList.add('flex');
			selectInput.querySelector('.select-icon-up').classList.remove('hidden');
			selectInput.querySelector('.select-icon-down').classList.add('hidden');
			selectInput.setAttribute('aria-expanded', 'true');
		}
	};

	const closeDropdown = () => {
		optionsList.classList.remove('flex');
		optionsList.classList.add('hidden');
		selectInput.querySelector('.select-icon-up').classList.add('hidden');
		selectInput.querySelector('.select-icon-down').classList.remove('hidden');
		selectInput.setAttribute('aria-expanded', 'false');
		currentFocusIndex = -1;
	};

	selectInput.addEventListener('focus', (e) => {
		setTimeout(() => {
			openDropdown();
		}, 200);
	});

	selectInput.addEventListener('blur', (e) => {
		setTimeout(() => {
			const newFocusElement = document.activeElement;
			const isOptionFocused = options.some((opt) => opt === newFocusElement);

			if (!isOptionFocused) {
				closeDropdown();
			}
		}, 200);
	});

	const selectLabel = selectInput.querySelector(
		`label[for="${nativeSelect.id}"]`,
	);
	const activeBackground = selectLabel.getAttribute('data-active-background');
	if (CSS.supports('color', activeBackground)) {
		selectLabel.style.backgroundColor = activeBackground;
	} else {
		selectLabel.classList.add(activeBackground);
	}

	// Tastatursteuerung

	selectInput.setAttribute('tabindex', '0');
	selectInput.addEventListener('keydown', function (e) {
		const options = Array.from(optionsList.querySelectorAll('li'));

		switch (e.key) {
			case 'Enter':
			case ' ':
				e.preventDefault();
				if (currentFocusIndex >= 0) {
					selectOption(options[currentFocusIndex]);
				} else {
					toggleOptions(optionsList);
					currentFocusIndex = -1;
				}
				break;
			case 'Tab':
			case 'ArrowRight':
			case 'Escape':
				if (!optionsList.classList.contains('hidden')) {
					toggleOptions(optionsList);
					currentFocusIndex = -1;
				}
				break;

			case 'ArrowDown':
				e.preventDefault();
				if (optionsList.classList.contains('hidden')) {
					toggleOptions(optionsList);
				} else {
					currentFocusIndex = Math.min(
						currentFocusIndex + 1,
						options.length - 1,
					);
					updateFocus(options);
				}
				break;

			case 'ArrowUp':
				e.preventDefault();
				if (!optionsList.classList.contains('hidden')) {
					currentFocusIndex = Math.max(currentFocusIndex - 1, 0);
					updateFocus(options);
				}
				break;
		}
	});

	function selectOption(selectedOption) {
		nativeSelect.value = selectedOption.getAttribute('data-value');
		selectInput.querySelector('.select-curr-selected').innerText =
			selectedOption.innerText;
		selectedOption.classList.remove('bg-grayWhite', 'focused');
		toggleOptions(optionsList);
		checkValidity(nativeSelect);
		checkSelectValidity(nativeSelect);
		const event = new Event("optionSelected");
		selectedOption.dispatchEvent(event);
	}

	function updateFocus(options) {
		options.forEach((opt, index) => {
			if (index === currentFocusIndex) {
				opt.classList.add('bg-grayWhite', 'focused');
				opt.setAttribute('aria-selected', 'true');
				opt.scrollIntoView({ block: 'nearest' });
			} else {
				opt.classList.remove('bg-grayWhite', 'focused');
				opt.setAttribute('aria-selected', 'false');
			}
		});
	}

	selectInput.addEventListener('click', function (ev) {
		if (nativeSelect.disabled) return;
		ev.stopPropagation();

		const currOptions = selectInput.parentElement.querySelector(
			'.select-input-options',
		);
		const hasOptions =
			Array.from(currOptions.querySelectorAll('li')).length > 0;
		if (!hasOptions) return;
		if (!currOptions.classList.contains('hidden')) {
			closeDropdown();
		} else {
			toggleOptions(currOptions);
		}
	});
	const nativeSelectOptions = selectInput.parentElement.querySelectorAll(
		'.select-input > option',
	);
	nativeSelectOptions.forEach((option) => {
		if (!option.value) return;
		const newOption = document.createElement('li');
		newOption.classList.add('select-input-option');
		newOption.setAttribute('data-value', option.value);
		newOption.innerText = option.innerText;
		optionsList.insertAdjacentElement('beforeend', newOption);

		newOption.addEventListener('mousedown', function (e) {
			e.preventDefault();
		});

		newOption.addEventListener('click', function (ev) {
			const nativeSelect = option.parentElement;
			nativeSelect.value = newOption.getAttribute('data-value');
			toggleOptions(optionsList);
			const selectedDisplay = option.parentElement.parentElement.querySelector(
				'.select-curr-selected',
			);
			selectedDisplay.innerText = newOption.innerText;
			selectedDisplay.setAttribute('data-value', option.value);
			checkValidity(option.parentElement);
			checkSelectValidity(option.parentElement);
		});
	});
});

if (selectInputOptions.length > 0) {
	document.body.addEventListener('click', function (ev) {
		selectInputOptions.forEach((options) => {
			const selectUpIcon =
				options.parentElement.querySelector('.select-icon-up');
			const selectDownIcon =
				options.parentElement.querySelector('.select-icon-down');
			if (options.classList.contains('flex')) {
				if (
					!ev.target.parentElement.classList.contains('select-input-options')
				) {
					options.classList.remove('flex');
					options.classList.add('hidden');
					selectUpIcon.classList.add('hidden');
					selectDownIcon.classList.remove('hidden');
				}
			}
		});
	});
}

/**
 *
 * @param {string[]} options
 * @param input
 * @param displayOptionsContainer
 */
export function createSelectList(options, input, displayOptionsContainer) {
	const displayedOptionsWrapper =
		displayOptionsContainer ||
		input.parentElement.querySelector('.select-input-options');
	input.innerHTML = '';
	displayedOptionsWrapper.innerHTML = '';
	for (const value of options) {
		if (!value.trim()) continue;
		const option = document.createElement('option');
		option.innerText = value;
		option.value = value;

		input.insertAdjacentElement('beforeend', option);

		const displayedOption = document.createElement('li');
		displayedOption.innerText = value;
		displayedOption.setAttribute('data-value', value);
		displayedOption.className = 'select-input-option';
		displayedOptionsWrapper.insertAdjacentElement('beforeend', displayedOption);
		displayedOption.addEventListener('click', function (_) {
			const nativeSelect = option.parentElement;
			nativeSelect.value = displayedOption.getAttribute('data-value');
			toggleOptions(displayedOptionsWrapper);

			const selectedDisplay = option.parentElement.parentElement.querySelector(
				'.select-curr-selected',
			);
			selectedDisplay.innerText = displayedOption.innerText;
			selectedDisplay.setAttribute('data-value', option.value);
			checkValidity(option.parentElement);
			checkSelectValidity(option.parentElement);
		});
	}
}

const forms = document.querySelectorAll('form');
forms.forEach((form) => {
	form.setAttribute('novalidate', 'true');
});
